<template>
  <div class="hotspot">
    <div class="hotspot-nav">
      <span>行业热点</span>
      <i class="iconfont icon-xiaohuomiao"></i>
    </div>
    <div class="hotspot-list">
      <div v-for="(item, i) in dataList" :key="i" class="hotspot-item" @click="toDetiled(item.id)">
        <span class="sort">{{ i + 1 }}</span>
        <span class="text">{{ item.title }}</span>
        <span class="time">{{ item.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { hotArticlesTop10 } from '@/api/dynamic'
export default {
  filters: {},
  data() {
    return {
      dataList: []
    }
  },
  watch: {},
  created() {},
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      const list = await hotArticlesTop10()
      this.dataList = list
      this.setHotspotEmpty(list)
    },
    setHotspotEmpty(data) {
      if (!data.length > 0) return sessionStorage.setItem('isHotspotEmpty', true)
      sessionStorage.removeItem('isHotspotEmpty')
    },
    toDetiled(id) {
      this.$router.push({
        name: 'dynamicDetail',
        params: { id, type: 'hotspot' }
      })
    }
  }
}
</script>

<style lang="scss">
.hotspot {
  margin-top: 50px;
  padding: 24px;
  .hotspot-nav {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 28px;
    letter-spacing: 1px;
    .iconfont {
      color: #f4523b;
      padding-left: 8px;
    }
  }
  .hotspot-list {
    padding: 24px 0;
    font-family: PingFangSC-Medium, PingFang SC;
    .hotspot-item {
      padding-bottom: 16px;
      display: flex;
      justify-content: space-between;
      .sort {
        display: inline-block;
        width: 24px;
        height: 24px;
        text-align: center;
        line-height: 24px;
        border-radius: 2px;
        background: #cecece;
        font-size: 16px;
        font-weight: 600;
        color: #ffffff;
        margin-right: 8px;
      }
      .text {
        flex: 1;
        box-sizing: border-box;
        padding-right: 16px;
        display: block;
        overflow: hidden;
        font-size: 16px;
        font-weight: 500;
        color: #333333;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* 可以显示的行数，超出部分用...表示*/
        -webkit-box-orient: vertical;
        cursor: pointer;
      }
      .time {
        float: right;
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        letter-spacing: 1px;
      }
    }
    .hotspot-item:nth-of-type(1) {
      .sort {
        background: #ff4242;
      }
    }
    .hotspot-item:nth-of-type(2) {
      .sort {
        background: #fe8434;
      }
    }
    .hotspot-item:nth-of-type(3) {
      .sort {
        background: #faab0e;
      }
    }
  }
}
</style>
